import React, { Component } from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

class ageSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      age: ""
    };

    this.triggetNext = this.triggetNext.bind(this);
  }

  triggetNext() {
    this.setState({ trigger: true }, () => {
      this.props.triggerNextStep();
    });
  }

  render() {
  
    let handleChange = (event) => {
      console.log(event.target.value);
      this.setState({
        age: event.target.value
      })
      localStorage.setItem("age", event.target.value);
      this.triggetNext();
    };

    const menuList = [];
    for(let i=1; i <= 100; i++){
      menuList.push(<MenuItem value={i}>{i}</MenuItem>);
    }

    const { steps } = this.props;
    const language = steps.language ? steps.language.value : 'english';

    return (
      <div> 
        <FormControl style={{width: "140px", marginRight: "200px", backgroundColor: "#f0f5ff"}}>
    <InputLabel id="demo-simple-select-label" style={{fontWeight: "400", fontSize: "13px"}}>{language === "english" ? "Select your Age" : "अपनी उम्र चुनें"} </InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={this.state.age}
          onChange={handleChange}
        >
          {menuList}
        </Select>
      </FormControl>
      </div>
    );
  }
}

export default ageSelect;